import * as moment from "moment"
import * as lookup from "../../../static/lookup.json"
import { getAge } from "./helperFunctions"
import { guaranteedFutureMapper } from "./helper/mapper/guaranteedFutureDataLayerMapper"

export function convertJson(payload,){
    let requestJSON = {}
    payload.forEach(page => {
        requestJSON[page.pageId] = {}
        page.pageData.forEach(section => {
            requestJSON[page.pageId][section.sectionId] = section.sectionData
        });
    });
    return requestJSON
}

export function dataLayerConvertJson(payload, journeyId, pageId, sectionId) {
    let applicationJSON2 = {}
    // applicationJSON2['lifeAssuredDetails'] = {}

    if(journeyId === "guaranteedFutureJourney") {
        applicationJSON2 = guaranteedFutureMapper(payload, journeyId, pageId, sectionId, applicationJSON2)
    }
    return applicationJSON2
} 

export function valueParser(data, key1, key2, key3) {
    if (!data || !key1 || !key2 || !key3) {
        return ""
    }
    return data[key1] ? (data[key1][key2] ? data[key1][key2][key3] || "" : "") : ""
}

export function fullNameCoverter(name) {
    let partedName = {
        firstName: "",
        middleName: "",
        lastName: "",
        fullName : ""
    }
    let slpitName = name.trim().split(' ');
    if (slpitName != null) {

        function StringBuffer() {
            this.__strings__ = new Array;
        }
        StringBuffer.prototype.append = function (str) {
            this.__strings__.push(str);
        };
        StringBuffer.prototype.toString = function () {
            return this.__strings__.join("");
        };
        let firstNameBuf = new StringBuffer();
        // Filter Space in name string
        slpitName = slpitName.filter((name)=>{
            return /\S/.test(name);
        })
        for (let i = 0; i < slpitName.length; i++) {
            if (i == (slpitName.length - 1) && i != 0) {
                partedName.lastName = slpitName[i].trim();
            } else if (slpitName.length > 2 && i == (slpitName.length - 2)) {
                partedName.middleName = slpitName[slpitName.length - 2].trim();
            } else {
                firstNameBuf.append(slpitName[i] + " ");
            }
            partedName.firstName = firstNameBuf.toString().trim();
        }
        partedName.firstName = firstNameBuf.toString().trim();
    }
    if (partedName.firstName && partedName.firstName.trim().length > 25) {
        const firstName = partedName.firstName;
        partedName.firstName = firstName.substring(0, 25);
    }
    if (partedName.middleName && partedName.middleName.trim().length > 25) {
        const middleName = partedName.middleName;
        partedName.middleName = middleName.substring(0, 25);
    }
    if (partedName.lastName && partedName.lastName.length > 25) {
        const lastName = partedName.lastName;
        partedName.lastName = lastName.substring(0, 25);
    }
    partedName["fullName"] = `${partedName?.firstName} ${partedName?.middleName || ""} ${partedName?.lastName || ""}`;
    return partedName;
}

export function policyTermValue(value, date) {

    if (value && date) {
      if (value == "WOL") {
        let age = Math.floor(moment(new Date()).diff(moment.unix(date).utcOffset("+05:30"), 'years', true))
        let policyTerm = Number(Number(100 - age)?.toFixed(2))
        return policyTerm
      } else if (value == "100-@LI_ENTRY_AGE") {
        let age = Math.floor(moment(new Date()).diff(moment.unix(date).utcOffset("+05:30"), 'years', true))
        let ppt = Number(Number(100 - age)?.toFixed(2))
        return ppt
      }
      else {
  
        let prem = Number(Number(value)?.toFixed(2))
        return prem
      }
    }
    else {
      return null
    }
  
}

export function repeatableJsonArrayMapper(payload, pageId, sectionID, applicationJSON2) {
    let json = [];
    let repeatabl = {
      insuranceDetailSection: {
        insuranceCompanyName: "insuranceCompany",
        insuranceSumAssured: "sumAssured",
        insuranceStatus: "currentStatus",
      },
      //lifeAssuredDetails.medicalDetails.familyHealthQuestions.medicalQuestions.familyHealthDetails
      SectionFlexiEdgeFillProposalMedicalInformation: {
        familyMemberHealthLA: "familyMember",
        ifAlive: "currentAge",
        ifAliveDisease: "disease",
        ifDeseased: "ageAtDeath",
        causeOfDeath: "causeOfDeath"
      },
      SectionFlexiEdgeFillProposalInsuranceHistory: {
        sumAssured: "sumAssured",
        nameOfinsuranceCompany: "insuranceCompany"
  
      },
      SectionULIPInsuranceHistory: {
        insuranceCompanyName: "insuranceCompany",
        insuranceSumAssured: "sumAssured",
        insuranceStatus: "currentStatus",
      },
      SectionPOSInsuranceHistory: {
        insuranceCompanyName: "insuranceCompany",
        insuranceSumAssured: "sumAssured",
        insuranceStatus: "currentStatus",
      },
      nomineeDetailsSection: {
        nomineeFullNameTitle: "title",
        nomineeFullName: "firstName",
        // "nomineeFullName": "middleName",
        // "nomineeFullName": "lastName",
        dob: "dob",
        nomineeRelationshipWithUser: "relationshipWithLa",
        gender: "gender",
        nomineeContactNumber: "contactDetails.mobileNo",
        nomineeEmail: "contactDetails.emailId",
        nomineeAddressLineOne: "communicationDetails.address1",
        nomineeAddressLineTwo: "communicationDetails.address2",
        nomineeAddressLineThree: "communicationDetails.areaTalukaTehsil",
        pincode: "communicationDetails.pinCode",
        state: "communicationDetails.state",
        country: "communicationDetails.country",
        nomineePercent: "percentage",
      },
      SectionFlexiEdgeFillProposalNomineeDetails: {
        nomineeTitle: "title",
        nomineeFullName: "firstName",
        // "nomineeFullName": "middleName",
        // "nomineeFullName": "lastName",
        nomineeDob: "dob",
        nomineeRelationshipWithUser: "relationshipWithLa",
        nomineeGender: "gender",
        nomineeCountryCode: "contactDetails.countryCode",
        nomineeContactNumber: "contactDetails.mobileNo",
        // nomineeEmail: "contactDetails.emailId",
        address1nominee: "communicationDetails.address1",
        address2nominee: "communicationDetails.address2",
        address3nominee: "communicationDetails.areaTalukaTehsil",
        nomineePincode: "communicationDetails.pinCode",
        stateNominee: "communicationDetails.state",
        nomineeCountry: "communicationDetails.country",
        cityNominee: "communicationDetails.cityMap",
        cityTextNominee: "communicationDetails.cityDistrict",
        nomineePercentCPF: "percentage",
      },
      SectionULIPDetailsOfNominee: {
        nomineeFullNameTitle: "title",
        nomineeFullName: "firstName",
        // "nomineeFullName": "middleName",
        // "nomineeFullName": "lastName",
        dob: "dob",
        nomineeRelationshipWithUser: "relationshipWithLa",
        gender: "gender",
        nomineeContactNumber: "contactDetails.mobileNo",
        nomineeEmail: "contactDetails.emailId",
        nomineeAddressLineOne: "communicationDetails.address1",
        nomineeAddressLineTwo: "communicationDetails.address2",
        nomineeAddressLineThree: "communicationDetails.address3",
        pincode: "communicationDetails.pinCode",
        state: "communicationDetails.state",
        country: "communicationDetails.country",
        nomineePercent: "percentage",
      },
      nriQuestionnairesSection: {
        NRIQuestionFiveDetail: "nriIssueTin",
      },
      FinancialSourceWeathQuestionnaire: {
        //company Audited
        financialDetails6Amount: "rs",
        financialDetails6Year: "profitYr",
  
        //Family details
        financialDetails4RWP: "relation",
        financialDetails4TOP: "policy_typ",
        financialDetails4NOI: "ins_name",
        financialDetails4PN: "pol_no",
        financialDetails4YOI: "issu_yr",
        financialDetails4SA: "sa",
        financialDetails4AP: "ap",
  
        // //SourceOfIncome
        // "financialDetails2SOI": "sourceType",
        // "financialDetails2FY18-19": "income",
        // "financialDetails2DocumentSubmitted1": "docSubmitd"
      },
    };
    if (payload && payload[pageId] && payload[pageId][sectionID]) {
      let arrayJson = []
      let arrayLenth = 0
      Object.keys(payload[pageId][sectionID]).forEach(formKey => {
        let jsonObject = {}
        if (Array.isArray(payload[pageId][sectionID][formKey])) {
          arrayLenth = payload[pageId][sectionID][formKey].length
        }
      })
      for (let i = 0; i < arrayLenth; i++) {
        let object = {}
        Object.keys(repeatabl[sectionID]).forEach(e => {
          if (sectionID === "SectionFlexiEdgeFillProposalNomineeDetails" && e === "cityTextNominee") {
            if (valueParser(payload, pageId, sectionID, "cityNominee") === "OTHERS") {
              object[repeatabl[sectionID][e]] = valueParser(payload, pageId, sectionID, "cityNominee")[i] || ''
            } else {
              object[repeatabl[sectionID][e]] = valueParser(payload, pageId, sectionID, e)[i] || ''
            }
          } else if(sectionID === "SectionFlexiEdgeFillProposalNomineeDetails" && e === "nomineeFullName"){
            object[repeatabl[sectionID][e]] = valueParser(payload, pageId, sectionID, e)[i] || ''
            object["NomineeFirstName"] = fullNameCoverter(valueParser(payload, pageId, sectionID, e)[i]).firstName || ''
            object["middleName"] = fullNameCoverter(valueParser(payload, pageId, sectionID, e)[i]).middleName || ''
            object["lastName"] = fullNameCoverter(valueParser(payload, pageId, sectionID, e)[i]).lastName || ''
          } else {
            object[repeatabl[sectionID][e]] = valueParser(payload, pageId, sectionID, e)[i] || ''
          }
        })
        arrayJson.push(object)
      }
      // console.log(payload)
      if (sectionID == "nomineeDetailsSection" && ((payload.fillProposalForm && payload.fillProposalForm.AppointeeDetailSection) || (payload.pageISelect360FillProposalForm && payload.pageISelect360FillProposalForm.AppointeeDetailSection))) {        // console.log(payload)
        let minorAppointeeIndex = []
        if (payload.fillProposalForm && payload.fillProposalForm[sectionID]) {
          payload.fillProposalForm[sectionID].dob.forEach((date, index) => {
            let age = moment(new Date()).diff(moment.unix(date).utcOffset("+05:30"), 'years', true)
            // logger.info(age, index)
            if (age < 18)
              minorAppointeeIndex.push(index)
          });
        } else if (payload.pageISelect360FillProposalForm && payload.pageISelect360FillProposalForm[sectionID]) {
          payload.pageISelect360FillProposalForm[sectionID].dob.forEach((date, index) => {
            let age = moment(new Date()).diff(moment.unix(date).utcOffset("+05:30"), 'years', true)
            // logger.info(age, index)
            if (age < 18)
              minorAppointeeIndex.push(index)
          });
        } else {
          return
        }
  
        minorAppointeeIndex.forEach(minorIndex => {
          let appointeeOBJ = {
            "firstName": fullNameCoverter(valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeFullName")).firstName,
            "middleName": fullNameCoverter(valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeFullName")).middleName,
            "lastName": fullNameCoverter(valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeFullName")).lastName,
            "fullName": valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeFullName"),
            "title": valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeFullNameTitle"),
            "relationshipWithNominee": valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeRelationWithUser"),
            "dob": valueParser(payload, pageId, "AppointeeDetailSection", "dob"),
            "gender": valueParser(payload, pageId, "AppointeeDetailSection", "gender"),
            "contactDetails": {
              "mobileNo": valueParser(payload, pageId, "AppointeeDetailSection", "AppointeeContactNumber"),
            }
          }
          arrayJson[minorIndex]['appointee'] = appointeeOBJ
        })
      }
      else if (sectionID == "SectionFlexiEdgeFillProposalNomineeDetails" && (payload.PageFlexiEdgeFillProposalForm && payload.PageFlexiEdgeFillProposalForm.FlexiEdgeFillProposalAppointeeSection)) {        // console.log(payload)
        let minorAppointeeIndex = []
        if (payload.PageFlexiEdgeFillProposalForm && payload.PageFlexiEdgeFillProposalForm[sectionID]) {
          payload.PageFlexiEdgeFillProposalForm[sectionID].nomineeDob.forEach((date, index) => {
            let age = moment(new Date()).diff(moment.unix(date).utcOffset("+05:30"), 'years', true)
            // logger.info(age, index)
            if (age < 18)
              minorAppointeeIndex.push(index)
          });
        } else {
          return
        }
  
        minorAppointeeIndex.forEach(minorIndex => {
          let appointeeOBJ = {
            "firstName": fullNameCoverter(valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "fullnameNominee")).firstName,
            "middleName": fullNameCoverter(valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "fullnameNominee")).middleName,
            "lastName": fullNameCoverter(valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "fullnameNominee")).lastName,
            "fullName": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "fullnameNominee"),
            "title": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "titleNominee"),
            "relationshipWithNominee": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "nomineeRelationship"),
            "dob": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "DOBnominee"),
            "gender": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "AppointeeGender"),
            "contactDetails": {
              "countryCode": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "countryCodeNominee"),
              "mobileNo": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "contactNominee"),
            },
            "communicationDetails": {
              "country": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "appointeeCountry"),
              "address1": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "address1appointee"),
              "address2": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "address2appointee"),
              "areaTalukaTehsil": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "address3appointee"),
              "pinCode": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "appointeePincode"),
              "state": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "appointeeState"),
              "cityMap": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "cityAppointee"),
              "cityDistrict": valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "cityAppointee") !== "OTHERS" ? valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "cityAppointee") : valueParser(payload, pageId, "FlexiEdgeFillProposalAppointeeSection", "cityNameAppointee"),
            }
          }
          if (!arrayJson[minorIndex]) {
            arrayJson[minorIndex] = {};
          }
          arrayJson[minorIndex]['appointee'] = appointeeOBJ
        })
      }
      return arrayJson
    }
    else {
      return json
    }
  }